<template>
  <div>
    <section class="travel-main-box" v-if="PostData.Post != null">
      <div class="container">
        <div class="box">
          <div class="title-box">
            <h1>
              {{ PostData.Post.Title }}
            </h1>
            <div class="share-box">
              <div
                class="time"
                v-if="PostData.Post.IsShowPublicTime ? true : false"
              >
                {{ PostData.Post.PublicStartTime | timeString("YYYY-MM-DD") }}
              </div>
              <ul class="share" v-if="false">
                <li>
                  <a
                    :href="PostData.ShareUrl_Facebook"
                    target="_blank"
                    :title="$t('分享至Facebook, 另開新視窗')"
                    ><img class="svg icon" src="img/icon-fb.svg" alt=""
                  /></a>
                </li>
                <li>
                  <a
                    :href="PostData.ShareUrl_Twitter"
                    target="_blank"
                    :title="$t('分享至Twitter, 另開新視窗')"
                    ><img class="svg icon" src="img/icon-twitter.svg" alt=""
                  /></a>
                </li>
                <!-- <li>
                  <a href="">
                    <img class="svg icon" src="./img/icon-share.svg" alt="" />
                  </a>
                </li> -->
              </ul>
            </div>
          </div>
          <hr />
          <div
            class="single-item"
            v-if="PostData.Post.Image == '' ? false : true"
          >
            <div class="box">
              <div class="img-box">
                <img
                  :src="PostData.SiteUrl + PostData.Post.Image"
                  :alt="PostData.Post.ImageAlt"
                />
              </div>
            </div>
          </div>
          <div
            id="divContent"
            class="text-box"
            v-html="PostData.Post.Content"
          ></div>
        </div>
        <div class="download-box" v-if="Attachments.length > 0 ? true : false">
          <h2>{{ $t("檔案下載") }}</h2>
          <ul class="download">
            <li v-for="(Attachment, index) in Attachments" :key="index">
              <a
                :href="
                  PostData.SiteUrl +
                  '/Platform/Htmlv2/Download?FId=' +
                  Attachment.FId
                "
                target="_blank"
                :title="
                  $t('下載') + Attachment.DisplayName + $t(', 另開新視窗')
                "
              >
                {{ Attachment.DisplayName }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";
import VueMeta from "vue-meta";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(VueMeta);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "分享至Facebook, 另開新視窗": "分享至Facebook, 另開新視窗",
    "分享至Twitter, 另開新視窗": "分享至Twitter, 另開新視窗",
    "檔案下載": "檔案下載",
    "下載": "下載",
    "另開新視窗": "另開新視窗",
  },
  en: {
    "分享至Facebook, 另開新視窗": "Share to Facebook",
    "分享至Twitter, 另開新視窗": "Share to Twitter",
    "檔案下載": "Download the file",
    "下載": "Download",
    "另開新視窗": "Open a new window",
  },
  jp: {
    "分享至Facebook, 另開新視窗": "Facebookでシェアする,新しいウィンドウで開く",
    "分享至Twitter, 另開新視窗": "Twitterでシェアする,新しいウィンドウで開く",
    "檔案下載": "ファイルをダウンロードする",
    "下載": "ダウンロード",
    "另開新視窗": "新しいウィンドウで開く",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Post",
  i18n,
  metaInfo: {
    meta: [
      { property: "og:url", content: "" },
      {
        property: "og:type",
        content: "article",
      },
      {
        property: "og:title",
        content: "",
      },
      {
        property: "og:description",
        content: "",
      },
      {
        property: "og:image",
        content: "",
      },
      {
        property: "og:image:secure_url",
        content: "",
      },
      {
        property: "og:image:width",
        content: "",
      },
      {
        property: "og:image:height",
        content: "",
      },
      {
        property: "og:url",
        content: "",
      },
    ],
  },
  metaInfo() {
    return {
      meta: [
        { property: "og:url", content: this.og_url },
        {
          property: "og:type",
          content: "article",
        },
        {
          property: "og:title",
          content: this.og_title,
        },
        {
          property: "og:description",
          content: this.og_description,
        },
        {
          property: "og:image",
          content: this.og_image,
        },
        {
          property: "og:image:secure_url",
          content: this.og_image_secure_url,
        },
        {
          property: "og:image:width",
          content: this.og_image_width,
        },
        {
          property: "og:image:height",
          content: this.og_image_height,
        },
      ],
    };
  },
  data() {
    return {
      PostData: {},
      Attachments: [],
      linkList: [],
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      og_url: "",
      og_title: "",
      og_description: "",
      og_image: "",
      og_image_secure_url: "",
      og_image_width: "",
      og_image_height: "",
    };
  },
  created: function () {
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Post", {
        params: { PId: this.$route.params.PId },
      })
      .then((response) => {
        this.PostData = response.data;
        if (this.PostData.Post.Attachment != "[]") {
          this.Attachments = JSON.parse(this.PostData.Post.Attachment);
        }
        if (this.$route.params.PId == 35 && Storage.isKey("voucher_uuid")) {
          var voucher_uuid = Storage.get("voucher_uuid");
          var voucher_url = Storage.get("voucher_url");
          this.PostData.Post.Content = this.PostData.Post.Content.replace(
            "$cookie.voucher_uuid",
            voucher_uuid
          );
          this.PostData.Post.Content = this.PostData.Post.Content.replace(
            "$cookie.voucher_url",
            voucher_url
          );
        }

        this.og_url =
          this.PostData.SiteUrl + "/#/Post/" + this.PostData.Post.PId;
        this.og_title = this.PostData.Post.Title;
        if (this.PostData.Post.SimpleContent) {
          this.og_description = this.PostData.Post.SimpleContent;
        } else {
          this.og_description = this.PostData.Post.Title;
        }
        if (this.PostData.Post.Image) {
          this.og_image = this.PostData.SiteUrl + this.PostData.Post.Image;
          this.og_image_secure_url =
            this.PostData.SiteUrl + this.PostData.Post.Image;
          this.og_image_width = "600";
          this.og_image_height = "315";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("travel");
    $(".wrapper").addClass("travel-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {
    let that = this;
    $("#divContent a").on("click", function () {
      var url = $(this).data("url");
      if (url) {
        var blank = $(this).data("target");
        if (blank && blank == "_blank") {
          that.gotoUrl(url, true);
        } else {
          that.gotoUrl(url, false);
        }
      }
    });
  },
  methods: {
    gotoUrl(url, blank) {
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          url,
          blank ? "_system" : "_blank",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
            this.$t("關閉") +
            ",closebuttoncolor=#ffffff"
        );
      } else {
        if (blank) {
          window.open(url, "_blank");
        } else {
          window.open(url);
        }
      }
    },
  },
};

Vue.filter("timeString", function (value, myFormat) {
  return moment(value).format(myFormat || "YYYY-MM-DD, HH:mm:ss");
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Post.vue